import { Injectable } from '@angular/core';
import { Observable, of, map } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import {
	categoryInterface,
	changeTypeInterface,
	scopeInterface,
	serviceTypeInterface,
	severityInterface,
	solutionAreaInterface,
	topicInterface,
} from 'src/app/util/interfaces/requestClassification';
import { environment } from 'src/environments/environment';
import { enduserInterface } from 'src/app/util/interfaces/enduser';

@Injectable({
	providedIn: 'root',
})
export class RequestClassificationService {
	private getScopeUrl = environment.baseApiUrl + 'request/classification/{idServiceType}/scope';
	private getCategoryUrl = environment.baseApiUrl + 'request/classification/{idServiceType}/{idScope}/category';
	private getTopicUrl = environment.baseApiUrl + 'request/classification/{idServiceType}/{idCategory}/topic';
	private getSolutionAreaUrl = environment.baseApiUrl + 'request/classification/{idServiceType}/{idTopic}/solutionArea';
	private getSeverityUrl = environment.baseApiUrl + 'request/classification/{idServiceType}/{idTopic}/severity';
	private getAvailableAnalystsUrl = environment.baseApiUrl + 'solutionarea/solutionarea/{idSolutionArea}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	// getServiceType(): Observable<serviceTypeInterface[]> {
	//   let mockServiceType : serviceTypeInterface[] = [
	//     {"id":"1", "label":"Problem", "name":"Problem"},
	//     {"id":"2", "label":"Incident", "name":"Incident"},
	//     {"id":"3", "label":"Change", "name":"Change"},
	//     {"id":"5", "label":"Complaint", "name":"Complaint"},
	//     {"id":"6", "label":"Service Request", "name":"Service Request"},
	//   ]

	//   return of(mockServiceType);
	// }

	getScope(idServiceType: string, idCustomer: string, idCmdb?: string, idAnalyst?: string): Observable<scopeInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getScopeUrl = this.getScopeUrl.replace('{idServiceType}', idServiceType);
		getScopeUrl += `?idCust=${idCustomer}`;
		if (idAnalyst) getScopeUrl += `&idAnalyst=${idAnalyst}`;
		if (idCmdb) getScopeUrl += `&idCmdb=${idCmdb}`;
		return this.http.get<scopeInterface[]>(getScopeUrl, { headers: headers }).pipe(
			map((scopes: scopeInterface[]) => {
				const newScopeArray: scopeInterface[] = [];

				for (const scope of scopes) {
					const newScope: scopeInterface = {
						id: <string>scope.id,
						name: scope.name,
						label: scope.name,
						allowedCiTypes: scope.allowedCiTypes,
						mandatoryCiBinding: (<any>scope).mandatory,
					};

					newScopeArray.push(newScope);
				}

				return newScopeArray;
			})
		);
	}

	getCategory(idServiceType: string, idScope: string, idCustomer: string, idAnalyst?: string): Observable<categoryInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getCategoryUrl = this.getCategoryUrl.replace('{idServiceType}', idServiceType).replace('{idScope}', idScope);
		getCategoryUrl += `?idCust=${idCustomer}`;
		if (idAnalyst) getCategoryUrl += `&idAnalyst=${idAnalyst}`;
		return this.http.get<categoryInterface[]>(getCategoryUrl, { headers: headers }).pipe(
			map((categories: categoryInterface[]) => {
				const newCategoryArray: categoryInterface[] = [];

				for (const category of categories) {
					const newCategory: categoryInterface = {
						id: <string>category.id,
						name: category.name,
						label: category.name,
					};

					newCategoryArray.push(newCategory);
				}

				return newCategoryArray;
			})
		);
	}

	getTopic(idServiceType: string, idCategory: string, idCustomer: string, idAnalyst?: string): Observable<topicInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getTopicUrl = this.getTopicUrl.replace('{idServiceType}', idServiceType).replace('{idCategory}', idCategory);
		getTopicUrl += `?idCust=${idCustomer}`;
		if (idAnalyst) getTopicUrl += `&idAnalyst=${idAnalyst}`;
		return this.http.get<topicInterface[]>(getTopicUrl, { headers: headers }).pipe(
			map((topics: topicInterface[]) => {
				const newTopicArray: topicInterface[] = [];

				for (const topic of topics) {
					const newTopic: topicInterface = {
						id: <string>topic.id,
						name: topic.name,
						label: topic.name,
					};

					newTopicArray.push(newTopic);
				}

				return newTopicArray;
			})
		);
	}

	getSolutionArea(idServiceType: string, idTopic: string, idCustomer: string, idAnalyst?: string): Observable<solutionAreaInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getSolutionAreaUrl = this.getSolutionAreaUrl.replace('{idServiceType}', idServiceType).replace('{idTopic}', idTopic);
		getSolutionAreaUrl += `?idCust=${idCustomer}`;
		if (idAnalyst) getSolutionAreaUrl += `&idAnalyst=${idAnalyst}`;
		return this.http.get<solutionAreaInterface[]>(getSolutionAreaUrl, { headers: headers }).pipe(
			map((solutionAreas: solutionAreaInterface[]) => {
				const newSolutionAreaArray: solutionAreaInterface[] = [];

				for (const solutionArea of solutionAreas) {
					const newSolutionArea: solutionAreaInterface = {
						id: <string>solutionArea.id,
						name: solutionArea.name,
						label: solutionArea.name,
					};

					newSolutionAreaArray.push(newSolutionArea);
				}

				return newSolutionAreaArray;
			})
		);
	}

	getSeverity(idServiceType: string, idTopic: string, idCustomer: string, idAnalyst?: string): Observable<severityInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getSeverityUrl = this.getSeverityUrl.replace('{idServiceType}', idServiceType).replace('{idTopic}', idTopic);
		getSeverityUrl += `?idCust=${idCustomer}`;
		if (idAnalyst) getSeverityUrl += `&idAnalyst=${idAnalyst}`;
		return this.http.get<any>(getSeverityUrl, { headers: headers }).pipe(
			map((severity: any[]) => {
				const newSeverityArray: severityInterface[] = [];

				for (const solutionArea of severity) {
					const newSeverity: severityInterface = {
						id: <string>solutionArea.id,
						name: solutionArea.name,
						label: solutionArea.name,
						severity: solutionArea.name,
					};

					newSeverityArray.push(newSeverity);
				}

				return newSeverityArray;
			})
		);
	}

	getChangeType(): Observable<changeTypeInterface[]> {
		const mockChangeType: changeTypeInterface[] = [
			{ id: '1', label: 'Fast Track', name: 'Fast Track' },
			{ id: '2', label: 'Standard', name: 'Standard' },
			{ id: '3', label: 'Non-Standard (Small)', name: 'Non-Standard (Small)' },
			{ id: '4', label: 'Non-Standard (Medium)', name: 'Non-Standard (Medium)' },
			{ id: '5', label: 'Non-Standard (Large)', name: 'Non-Standard (Large)' },
		];

		return of(mockChangeType);
	}
}
